import React from 'react';
import { Link } from 'react-router-dom';

import logo from '../../assets/images/logo.svg';

const Logo = () => {
  return (
    <Link to="/" className="logo" title="">
      <img src={logo} alt="logo" />
    </Link>
  )
};

export default Logo;



// WEBPACK FOOTER //
// ./src/components/shared/Logo.js